"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RpcError = /** @class */ (function () {
    function RpcError(payload) {
        this.jsonrpc = '2.0';
        // noinspection TypeScriptValidateTypes link:https://youtrack.jetbrains.com/issue/WEB-36766
        Object.assign(this, payload);
        this.id = payload.id;
        if (payload.headers) {
            this.headers = payload.headers;
        }
        this.error = payload.error || {
            data: null,
            message: null,
            code: null,
        };
    }
    RpcError.prototype.getId = function () {
        return this.id;
    };
    RpcError.prototype.getError = function () {
        return this.error;
    };
    RpcError.prototype.getCode = function () {
        return this.error.code;
    };
    RpcError.prototype.getMessage = function () {
        return this.error.message;
    };
    RpcError.prototype.getData = function () {
        return this.error.data;
    };
    RpcError.prototype.getHeaders = function () {
        return this.headers;
    };
    return RpcError;
}());
exports.default = RpcError;
//# sourceMappingURL=RpcError.js.map